<template>
  <!-- Overlay to dim out everything in the background and disable scroll if the menu is open -->
  <div class="fixed inset-0 z-30 bg-[#E3E3E399] backdrop-blur-[3px]" />
</template>
